<template lang="pug">
.thread-mentor-comment(:class='{ "is-latest": isLatest }')
    .comment-contents(v-if='!editing')
      header.mentor-comment-header
        h2.thread-mentor-comment__title
          a.thread-mentor-comment__name
            | {{ mentorComment.user.private_name }}
        time.thread-mentor-comment__created-at(
          :class='{ "is-active": activating }',
          :datetime='mentorCommentableCreatedAt')
          | {{ updatedAt }}
      hr.a-border-tint
      .therad-mentor-comment__description
        .a-long-text.is-md(v-html='markdownDescription')
      footer.mentor-comment-footer(
        v-if='mentorComment.user.id === currentUser.id')
        .mentor-comment-actions
          ul.mentor-comment-actions__items
            li.card-main-actions__item.is-sub(@click='editMentorComment($event)')
              .mentor-comment-actions__muted-action.is-de
                i.fa-solid.fa-pen(
                  :class='{ "is-latest": isLatest }'
                )
            li.card-main-actions__item.is-sub(@click='deleteMentorComment')
              .mentor-comment-actions__muted-action.is-de
                i.fa-solid.fa-trash
    .a-card(v-show='editing')
      .a-form-tabs.js-tabs
        .a-form-tabs__tab.js-tabs__tab(
          :class='{ "is-active": isActive("mentor-comment") }',
          @click='changeActiveTab("mentor-comment")')
          | コメント
        .a-form-tabs__tab.js-tabs__tab(
          :class='{ "is-active": isActive("preview") }',
          @click='changeActiveTab("preview")')
          | プレビュー
      .a-markdown-input.js-markdown-parent
        .a-markdown-input__inner.js-tabs__content(
          :class='{ "is-active": isActive("mentor-comment") }')
          .form-textarea
            .form-textarea__body
              textarea.a-text-input.a-markdown-input__textarea(
                v-model='body',
                name='new_mentor_comment[body]'
                :id='`js-mentor-comment-${this.mentorComment.id}`',
                :data-preview='`#js-comment-preview-${this.mentorComment.id}`',
                :data-input='`.js-comment-file-input-${this.mentorComment.id}`')
            .form-textarea__footer
              .form-textarea__insert
                label.a-file-insert.a-button.is-xs.is-text-reversal.is-block
                  | ファイルを挿入
                  input(
                      :class='`js-comment-file-input-${this.mentorComment.id}`',
                      type='file',
                      multiple)
        .a-markdown-input__inner.js-tabs__content(
          :class='{ "is-active": isActive("preview") }')
          .a-long-text.is-md.a-markdown-input__preview(
              :id='`js-comment-preview-${this.mentorComment.id}`')
      hr.a-border-tint
      .card-footer
        .card-main-actions
          .card-main-actions__items
            .card-main-actions__item
              button.a-button.is-sm.is-primary.is-block(@click='updateMentorComment',v-bind:disabled='!validation')
                | 更新
            .card-main-actions__item
              button.a-button.is-sm.is-secondary.is-block(@click='cancel')
                | キャンセル
</template>
<script>
import CSRF from 'csrf'
import MarkdownInitializer from 'markdown-initializer'
import TextareaInitializer from 'textarea-initializer'
import autosize from 'autosize'
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import role from 'role'

dayjs.locale(ja)

export default {
  mixins: [role],
  props: {
    mentorComment: { type: Object, required: true },
    currentUser: { type: Object, required: true },
    isLatest: { type: Boolean, required: true }
  },
  data() {
    return {
      body: '',
      editing: false,
      isCopied: false,
      tab: 'mentor-comment',
      activating: false,
    }
  },
  computed: {
    mentorCommentableCreatedAt() {
      return dayjs(this.mentorComment.mentor_commentable.created_at).format()
    },
    markdownDescription() {
      const markdownInitializer = new MarkdownInitializer()
      return markdownInitializer.render(this.body)
    },
    updatedAt() {
      return dayjs(this.mentorComment.updated_at).format('YYYY年MM月DD日(dd) HH:mm')
    },
    validation() {
      return this.body.length > 0
    }
  },
  created() {
    this.body = this.mentorComment.body
  },
  mounted() {
    TextareaInitializer.initialize(`#js-mentor-comment-${this.mentorComment.id}`)
    const mentorCommentAnchor = location.hash
    if (mentorCommentAnchor) {
      this.$nextTick(() => {
        location.replace(location.href)
      })
    }
  },
  methods: {
    isActive(tab) {
      return this.tab === tab
    },
    changeActiveTab(tab) {
      this.tab = tab
    },
    cancel() {
      this.body = this.mentorComment.body
      this.editing = false
    },
    editMentorComment(event) {
      this.editing = true
      this.$nextTick(function () {
        const textarea = document.querySelector(
          `#js-mentor-comment-${this.mentorComment.id}`
        )
        autosize.update(textarea)
        $(`.mentor-comment-id-${this.mentorComment.id}`).trigger('input')

        const clickedElement = event.target
        if (clickedElement.classList.contains('is-latest') == true) {
            const cardList = document.querySelector('.card-list.a-card');
            cardList.scrollTop = cardList.scrollHeight;
        }
      })
    },
    updateMentorComment() {
      if (this.body.length < 1) {
        return null
      }
      const params = {
        mentor_comment: { body: this.body }
      }
      fetch(`/api/mentor_comments/${this.mentorComment.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': CSRF.getToken()
        },
        credentials: 'same-origin',
        redirect: 'manual',
        body: JSON.stringify(params)
      })
        .then(() => {
          this.$emit('update', this.body, this.mentorComment.id)
          this.editing = false
        })
        .catch((error) => {
          console.warn(error)
        })
        .finally(() => {
          Prism.highlightAll()
        })
    },
    deleteMentorComment() {
      if (window.confirm('削除してよろしいですか？')) {
        this.$emit('delete', this.mentorComment.id)
      }
    }
  }
}
</script>